import { WebStorageStateStore, UserManagerSettings } from "oidc-client";
import { AppSettings } from "./app-settings";

export default {
    authority: AppSettings.IdentityApiUrlPrefix,
    client_id: "justisoneweb",
    redirect_uri: `${AppSettings.WindowOrigin}/assets/authentication/signin-oidc.html`,
    post_logout_redirect_uri: `${AppSettings.WindowOrigin}`,
    response_type: "code",
    scope: "openid profile justis.api justis.api.search justis.api.document justis.api.processing justis.api.graph justis.api.autocorrect offline_access",
    filterProtocolClaims: true,
    accessTokenExpiringNotificationTime: 60,
    automaticSilentRenew: true,
    loadUserInfo: true,
    userStore: new WebStorageStateStore({
        prefix: "vlex_",
        store: window.localStorage,
    })
} as UserManagerSettings;



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/oidc-settings.ts